/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown>, distance: NonNullable<unknown> }} Tracking_Mode_Segment_RouteInputs */

const vi_tracking_mode_segment_route = /** @type {(inputs: Tracking_Mode_Segment_RouteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Di chuyển ${i?.index} • ${i?.distance} km`)
};

/**

* @param {Tracking_Mode_Segment_RouteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_mode_segment_route = /** @type {((inputs: Tracking_Mode_Segment_RouteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Mode_Segment_RouteInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_mode_segment_route(inputs)
});